import React from 'react';
import { connect } from 'react-redux';

// TODO handle logos for integrations
// import FyorinLogo from './assets/fyorin-logo.svg'
import Tooltip from '@/tooltip';

const PaymentIntegrationEmployeeStatus = ({
    payByCheque,
    availablePaymentIntegrations,
    paymentIntegrationPending,
    paymentIntegrationId
}) => {

    const payByBank = typeof (payByCheque) === 'string' ? ['yes', 'true'].includes(payByCheque) : payByCheque
    const synced = paymentIntegrationPending || (!paymentIntegrationId && payByBank) || !payByBank

    if (!availablePaymentIntegrations || availablePaymentIntegrations.length === 0) return null;

    return (
        <>
            {availablePaymentIntegrations.map(integration => (
                    <div key={integration} style={{ marginLeft: 5, marginTop: 15, float: 'left' }}>
                        <Tooltip content={`${!synced ? "Employee is not synced with ${integration}" : 'Employee is Up To Date and synced'}`}>
                            <img src={""} style={{ height: 30, filter: !synced ? 'grayscale(100%)' : undefined }} />
                        </Tooltip>
                    </div>
                ))
            }
        </>
    );
};

const mapStateToProps = (state, ownProps) => {

	// TODO Get Connected Payment Systems
	const availablePaymentIntegrations = state?.integration?.payment?.availablePaymentIntegrations ?? []

    const { bankDetails } = { ...state.employee };
    const { paymentIntegrationPending, paymentIntegrationId } = { ...state?.employee?.employeeDetails }
    const { payByCheque } = { ...(bankDetails?.length > 0 && bankDetails[bankDetails.length - 1]) }

    return {
        paymentIntegrationPending,
        paymentIntegrationId,
        payByCheque,
        availablePaymentIntegrations,
    };
};

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentIntegrationEmployeeStatus);
